import { Component, OnInit } from "@angular/core";
import { DomSanitizer } from '@angular/platform-browser';
import { SharedService } from "../../../../../../modules/shared/services/shared.service";
import { ActivatedRoute } from "@angular/router";
import { UploadService } from "../../../../../../modules/shared/services/upload.service";
@Component({
    selector: "image-config",
    templateUrl: "./image-config.view.html",
    providers: []
})
export class ImageConfigView implements OnInit {
    baseUrl = "";
    imageConfig: any = {};
    currentLayout: string = "";
    basedOnDatas: any = [
        {
            label: "Speaker Profile Image",
            code: "speaker_img",
            type: "standard"
        },
        {
            label: "Dynamic Image",
            code: "dynamic_img",
            type: "standard"
        }
    ];
    path;
    html;
    constructor(
        public sharedService: SharedService,
        private activatedRoute: ActivatedRoute,
        private uploadService: UploadService,
        private sanitizer: DomSanitizer
    ) {
        this.path = this.activatedRoute.parent.routeConfig.path
        if (this.activatedRoute.parent.routeConfig.path == "session") {
            this.baseUrl = sharedService.sessionUrl;
            this.currentLayout = this.sharedService.sessionLayoutConfig[this.baseUrl].layout;
            this.imageConfig = this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig[
                this.sharedService.expansionStyle
            ].imageConfig;
            if (this.sharedService.sessionFileCustomFields != null) {
                this.sharedService.sessionFileCustomFields.forEach((cf) => {
                    this.basedOnDatas.push({
                        label: cf.name,
                        code: "custom_" + cf.code,
                        type: "custom",
                        customFieldId: cf.id
                    });
                });
            }
        } else if (this.activatedRoute.parent.routeConfig.path == "speaker") {
            this.currentLayout = this.sharedService.speakerLayoutConfig.layout;

            this.imageConfig = this.sharedService.speakerLayoutConfig.catalogConfig[
                this.sharedService.expansionStyle
            ].imageConfig;

            if (this.sharedService.speakerFileCustomFields != null) {
                this.sharedService.speakerFileCustomFields.forEach((cf) => {
                    this.basedOnDatas.push({
                        label: cf.name,
                        code: "custom_" + cf.code,
                        type: "custom",
                        customFieldId: cf.id
                    });
                });
            }
        }

        if(this.currentLayout == 'l_banner' && this.activatedRoute.parent.routeConfig.path == "session") {
            this.basedOnDatas = [
                {
                    label: "Dynamic Image",
                    code: "dynamic_img",
                    type: "standard"
                },
                {
                    label: "Online Session Thumbnail",
                    code: "thumbnail_img",
                    type: "standard"
                }
            ]
        }

        if (!this.imageConfig.dynamicImage) {
            this.imageConfig.dynamicImage = "assets/images/upload-image.png";
        }

        if (!this.imageConfig.banner) {
            this.imageConfig.banner = "assets/images/upload-image.png";
        }

        if (!this.imageConfig.webinarThumbnail) {
            this.imageConfig.webinarThumbnail = "assets/images/thumbnail-image.png";
        }

        if(!this.imageConfig.defaultThumbnailURL) {
            this.imageConfig.defaultThumbnailURL = "assets/images/upload-image.png";
        }

        this.html = this.imageConfig.displayIcon ? sanitizer.bypassSecurityTrustHtml(this.imageConfig.displayIcon) : "";


    }

    ngOnInit() {}

    imageChange(image) {}

    uploadEvent(file) {
        this.uploadService.fileUpload(file.formData).subscribe((resp) => {
            if (resp.body.hasOwnProperty("documentName")) {
                if (this.activatedRoute.parent.routeConfig.path == "session") {
                    if (this.imageConfig.basedOn === "dynamic_img") {
                        if(this.currentLayout != "l_banner") {
                            this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig[
                                this.sharedService.expansionStyle
                            ].imageConfig.dynamicImage = resp.body["documentPath"] + resp.body["documentName"];
                        } else if(this.currentLayout == "l_banner") {
                            this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig[
                                this.sharedService.expansionStyle
                            ].imageConfig.banner = resp.body["documentPath"] + resp.body["documentName"];
                        }
                        
                    } else if(this.imageConfig.basedOn === "thumbnail_img") {
                        this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig[
                            this.sharedService.expansionStyle
                        ].imageConfig.webinarThumbnail = resp.body["documentPath"] + resp.body["documentName"];
                    }
                } else if (this.activatedRoute.parent.routeConfig.path == "speaker") {
                    if (this.currentLayout != "l_banner") {
                        this.sharedService.speakerLayoutConfig.catalogConfig[
                            this.sharedService.expansionStyle
                        ].imageConfig.dynamicImage = resp.body["documentPath"] + resp.body["documentName"];
                    } else {
                        this.sharedService.speakerLayoutConfig.catalogConfig[
                            this.sharedService.expansionStyle
                        ].imageConfig.banner = resp.body["documentPath"] + resp.body["documentName"];
                    }
                }
            }
        });
    }

    onIconChange() {
        this.html = this.imageConfig.displayIcon ? this.sanitizer.bypassSecurityTrustHtml(this.imageConfig.displayIcon) : "";
    }
}
